const comma = (val) => (val ? `${val},` : '');

const addressToString = (values, setHasAddress) => {
  const hasAddress = values && typeof values === 'object';
  if (typeof setHasAddress === 'function') setHasAddress(hasAddress);
  if (!hasAddress) return null;
  const {
    entre_calle,
    y_calle,
    calle_principal,
    tipo_de_vialidad,
    numero_exterior,
    numero_interior,
    colonia_texto,
    cp_texto,
    municipio_texto,
    estado_texto,
  } = values;
  const codigo_postal = values.codigo_postal_index || values.codigo_postal;
  let entreCalles = '';
  if (entre_calle && y_calle) {
    entreCalles = `entre  ${entre_calle} ${y_calle ? 'y' : ''} ${y_calle}`.trim();
  } else if (entre_calle || y_calle) {
    entreCalles = `y ${entre_calle || y_calle}`.trim();
  }
  const numExterior = `${numero_exterior && numero_exterior !== 'S/N' ? 'Ext. #' : ''}${numero_exterior || ''}`;
  const numInterior = `${numero_interior && numero_interior !== 'S/N' ? 'Int. #' : ''}${numero_interior || ''}`;
  const colonia = colonia_texto || codigo_postal?.d_asenta || '';
  const codigo = cp_texto || codigo_postal?.d_codigo;
  const municipio = municipio_texto || codigo_postal?.municipio?.nom_mun || '';
  const estado = estado_texto || codigo_postal?.municipio?.estado?.nombre_de_AGEE || '';
  const pais = codigo_postal?.municipio?.estado?.pais?.descripcion || '';
  return [
    tipo_de_vialidad?.descripcion,
    calle_principal,
    comma(numExterior),
    comma(numInterior),
    entreCalles,
    codigo_postal?.d_tipo_asenta,
    comma(colonia),
    comma(codigo),
    comma(municipio),
    comma(estado),
    pais,
  ].join(' ').trim().replace(/,\s*$/, '');
};

export default addressToString;
